import script from "./IndicatorItem.vue?vue&type=script&setup=true&lang=js"
export * from "./IndicatorItem.vue?vue&type=script&setup=true&lang=js"

import "./IndicatorItem.vue?vue&type=style&index=0&id=8b46e170&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8b46e170"]])

export default __exports__